"use client";
const UserProfile = () => {
  // const subMenu = ["Add Module sub menu", "Edit sub menu"];
  return <div className="UserProfile">vsfvs</div>;
};

export default UserProfile;
